import { render, staticRenderFns } from "./bindTable.vue?vue&type=template&id=7145cb72&scoped=true&"
import script from "./bindTable.vue?vue&type=script&lang=js&"
export * from "./bindTable.vue?vue&type=script&lang=js&"
import style0 from "./bindTable.vue?vue&type=style&index=0&id=7145cb72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7145cb72",
  null
  
)

export default component.exports